import {Service} from "../Service";

export class LaboratorioService extends Service {
    constructor() {
        super('laboratorio/');
    }

    enviarRecepcion(idSolicitud, idEtapa) {
        return this.http.post(this.getUrl(['enviar-a', 'recoleccion'], {idSolicitud: idSolicitud, idEtapa: idEtapa}))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    aceptarDenegarODT(idSolicitud, idEtapa, form) {
        return this.http.post(this.getUrl(['enviar-a', 'produccion'], {idSolicitud: idSolicitud, idEtapa: idEtapa}),form)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    enviarIngreso(idSolicitud,idEtapa, form) {
        return this.http.post(this.getUrl(['enviar-a', 'ingreso'], {idSolicitud: idSolicitud,idEtapa: idEtapa}),form)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}
